function timer() {
    this.id;
    this.started;
    this.remaining;
    this.callback;
    this.autoPlay = false;

    this.set = function (fxn, delay) {

        clearTimeout(this.id);
        this.callback = fxn;
        this.remaining = delay;
        this.started = new Date();

        if (!this.autoPlay) return;
        this.id = setTimeout(this.callback, delay);
    };

    this.pause = function () {
        this.autoPlay = false;
        this.remaining = Math.max(
            this.remaining - (new Date() - this.started),
            0
        );
        
        clearTimeout(this.id);
    };

    this.play = function (force_restart) {
        if (!force_restart) return;
        this.autoPlay = true;
        this.started = new Date();
        
        this.id = setTimeout(this.callback, this.remaining);
    };

    this.stop = function () {
        clearTimeout(this.id);
        this.remaining = null;
    };

    this.getTimeLeft = function () {
        return this.remaining;
    };
}

module.exports = { timer };
